import * as React from 'react'

const BAR_COUNT = 8
const COLOR = '#B3B3FF'

// The spinner from the design (HI-UPDATES-2026, Update brief), drawn as eight bars around the center.
// The caller animates it: each bar's opacity cycles, staggered by `--bar-index`.
const BriefAutofillSpinner = ({ barClassName, ...props }) => (
  <svg width="49" height="49" viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    {Array.from({ length: BAR_COUNT }, (_, index) => (
      <line
        key={index}
        className={barClassName}
        style={{ '--bar-index': index }}
        x1="24.5"
        y1="6"
        x2="24.5"
        y2="14"
        stroke={COLOR}
        strokeWidth="4"
        strokeLinecap="round"
        transform={`rotate(${(360 / BAR_COUNT) * index} 24.5 24.5)`}
      />
    ))}
  </svg>
)

export default BriefAutofillSpinner
